import React, {useEffect, useState} from 'react';
import {Box, Stack, TextField} from '@mui/material';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import RequiredCheckbox from './Shared/RequiredCheckbox';
import RichEditor from './Shared/RichEditor';
import RichEditorResultText from './Shared/RichEditorResultText';
import {stripHtmlTags} from './AdditionalNotes';

const PreviousSchoolName = ({
                                index,
                                id,
                                fieldKey,
                                value,
                                onChange,
                                description,
                                enableValidation,
                                isEditMode,
                                isFormArchived,
                                readonly,
                                placeholderValues,
                                accessLevel,
                                submitMode,
                                error,
                                audience,
                                recipientType,
                            }) => {
    const [currentValue, setCurrentValue] = useState(description ?? '');
    useEffect(() => {
        setCurrentValue(description ?? '');
    }, [description]);

    const handleDescriptionChange = (nextValue) => {
        setCurrentValue(nextValue);

        if (!onChange) return;

        onChange({
            index,
            description: stripHtmlTags(nextValue),
            formattedDescription: nextValue,
        });
    };

    return (
        <Box key={`PreviousSchoolName_${id}`} sx={{mt: 2}}>
            {isEditMode
                ? <>
                    <RichEditor
                        value={description}
                        onChange={onChange}
                        id={id}
                        index={index}
                        isEditMode={isEditMode}
                        isFormLive={isFormArchived}
                        accessLevel={accessLevel}
                        currentDescription={currentValue}
                        setCurrentDescription={handleDescriptionChange}
                        audience={audience}
                        recipientType={recipientType}
                    />

                    <Stack
                        flexDirection="row"
                        justifyContent="space-between"
                        gap={3}
                        mb={2}
                    >
                        <RequiredCheckbox
                            enableValidation={enableValidation}
                            index={index}
                            onChange={onChange}
                            isFormArchived={isFormArchived || !!fieldKey}
                        />
                    </Stack>
                </>
                : <>
                    <RichEditorResultText
                        id={id}
                        description={description}
                        placeholderValues={placeholderValues}
                        readonly={readonly}
                        enableValidation={enableValidation}
                        audience={audience}
                        recipientType={recipientType}
                        submitMode={submitMode}
                    />
                    {!readonly
                        ? <TextField
                            fullWidth
                            value={value || ''}
                            required={enableValidation}
                            disabled={!submitMode}
                            helperText={error}
                            error={!!error}
                            onChange={e => onChange({id, value: e.target.value})}
                            type="text"
                        />
                        : <Typography sx={{
                            width: {xs: '80vw', sm: '60vw', md: '45vw', lg: '45vw', xl: '45vw'},
                            wordWrap: 'break-word',
                            overflowWrap: 'break-word'
                        }}>
                            {value}
                        </Typography>
                    }
                </>
            }
        </Box>
    );
};
PreviousSchoolName.propTypes = {
    id: PropTypes.string,
    fieldKey: PropTypes.string,
    value: PropTypes.string,
    index: PropTypes.number,
    description: PropTypes.string,
    onChange: PropTypes.func,
    enableValidation: PropTypes.bool,
    isEditMode: PropTypes.bool,
    isFormArchived: PropTypes.bool,
    readonly: PropTypes.bool,
    placeholderValues: PropTypes.object,
    accessLevel: PropTypes.number,
    submitMode: PropTypes.bool,
    error: PropTypes.string,
    audience: PropTypes.number,
    recipientType: PropTypes.string
};

export default PreviousSchoolName;